import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'displayDaySuffix',
})
export class DisplayDaySuffixPipe implements PipeTransform {
	transform(value: number, ...args: unknown[]): string {
		if (value) {
			return `${value.toLocaleString()} ${value > 1 ? 'days' : 'day'}`;
		} else {
			return 'Today';
		}
	}
}
